<script setup lang="ts">
import {onMounted, ref} from "vue";
import {label} from "../../mixins/translations";
import {useCartStore} from "../../stores/cart";
import Modal from "../Modal.vue";

const open = ref(false);
const cartStore = useCartStore();

const afterAdding = () => {
    open.value = true;
}

onMounted(() => {
    cartStore.events.on('afterAdding', afterAdding);
});
</script>
<template>
    <Modal :open="open !== false" @updateOpen="open = !open;">
        <template #trigger-wrapper>&nbsp;</template>
        <template #title>
            <div class="w-full">
                <div class="text-xl w-full text-secondary-700 font-extrabold text-center">{{ label('site.product.popup.title') }}</div>
            </div>
        </template>
        <template #description>
            <div class="paragraph text-base font-normal text-secondary-600 leading-8 text-center mt-3">{{ label('site.product.popup.content') }}</div>

            <div class="flex mt-4 gap-x-4 text-center justify-center">
                <button @click.prevent="open = false;"
                        class="py-3 px-6 pointer rounded-full flex font-semibold items-center justify-center text-white bg-primary hover:bg-primary-300 transition-all duration-500 z-20">
                    <span>{{ label('site.product.popup.continue_shopping') }}</span>
                </button>
                <a href="/cart/"
                        class="py-3 px-6 pointer rounded-full font-semibold flex items-center justify-center text-white bg-slate-700 hover:bg-slate-800 transition-all duration-500">
                    {{ label('site.product.popup.cart') }}
                </a>
            </div>
        </template>
    </Modal>
</template>
